import { polaroidDefaultMoldura } from "@/constants/configEditor";
import { tiposDeFotos } from "@/constants/tipoFoto.js";
import { BaseFormat } from "./baseFormat";

export class PolaroidFormat extends BaseFormat {
  constructor(options = {}) {
    super(options);
    this.previewScale = options.previewScale ?? 0.5;
  }

  get tipo() {
    return "polaroid";
  }

  get canvasSize() {
    return {
      width: 1200 * this.previewScale,
      height: 1600 * this.previewScale,
    };
  }

  get scaleFinal() {
    return 1 / this.previewScale;
  }

  get defaultMoldura() {
    // A moldura do evento tem prioridade: no evento a polaroid nunca cai na
    // moldura branca padrão.
    if (this.molduraFixa) {
      return this.molduraFixa;
    }
    return polaroidDefaultMoldura;
  }

  filterMolduras(listaMolduras, orientationId) {
    return listaMolduras.filter(
      (m) =>
        m.dados.orientacao === orientationId &&
        m.dados.tipo === tiposDeFotos.POLAROID
    );
  }
}
